import React from 'react';
import { motion } from 'framer-motion';

export const OceanBackground = () => {
  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden" style={{ zIndex: 0 }}>
      {/* Sun - behind content, positioned to not overlap with text */}
      <motion.div
        className="absolute top-[3%] right-[5%] w-16 h-16 sm:w-20 sm:h-20 rounded-full"
        style={{
          background: 'radial-gradient(circle, #FACC15 0%, #FB923C 100%)',
          boxShadow: '0 0 50px rgba(250, 204, 21, 0.5)',
          zIndex: -1
        }}
        animate={{ scale: [1, 1.05, 1] }}
        transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}
      />

      {/* Seagulls - stay on top */}
      <motion.div
        className="absolute top-[12%]"
        style={{ zIndex: 5 }}
        animate={{ x: [-50, 400] }}
        transition={{ duration: 15, repeat: Infinity, ease: 'linear' }}
      >
        <SeagullSVG />
      </motion.div>
      <motion.div
        className="absolute top-[8%]"
        style={{ zIndex: 5 }}
        animate={{ x: [-80, 420] }}
        transition={{ duration: 18, repeat: Infinity, ease: 'linear', delay: 5 }}
      >
        <SeagullSVG size={20} />
      </motion.div>

      {/* Clouds - behind content */}
      <motion.div
        className="absolute top-[15%] left-[10%] opacity-40"
        style={{ zIndex: 1 }}
        animate={{ x: [0, 50, 0] }}
        transition={{ duration: 20, repeat: Infinity, ease: 'easeInOut' }}
      >
        <CloudSVG />
      </motion.div>
      <motion.div
        className="absolute top-[20%] right-[20%] opacity-30"
        style={{ zIndex: 1 }}
        animate={{ x: [0, -30, 0] }}
        transition={{ duration: 25, repeat: Infinity, ease: 'easeInOut' }}
      >
        <CloudSVG size={60} />
      </motion.div>

      {/* Waves - behind all content with smooth CSS animation */}
      <div className="absolute bottom-0 left-0 right-0 h-[35vh]" style={{ zIndex: 1 }}>
        <WaveLayer color="rgba(56, 189, 248, 0.25)" duration={20} offset={0} />
        <WaveLayer color="rgba(14, 165, 233, 0.35)" duration={15} offset={15} reverse />
        <WaveLayer color="rgba(2, 132, 199, 0.45)" duration={25} offset={30} />
      </div>
    </div>
  );
};

// Using CSS animation instead of framer-motion for smoother wave animation
const WaveLayer = ({ color, duration, offset, reverse = false }) => (
  <div
    className="absolute bottom-0 left-0 w-[200%] h-full"
    style={{ 
      bottom: offset,
      animation: `waveSlide ${duration}s linear infinite ${reverse ? 'reverse' : ''}`
    }}
  >
    <svg viewBox="0 0 1440 320" className="w-full h-full" preserveAspectRatio="none">
      <path
        fill={color}
        d="M0,160L48,176C96,192,192,224,288,213.3C384,203,480,149,576,138.7C672,128,768,160,864,181.3C960,203,1056,213,1152,197.3C1248,181,1344,139,1392,117.3L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
      />
    </svg>
    <style>{`
      @keyframes waveSlide {
        0% { transform: translateX(0); }
        100% { transform: translateX(-50%); }
      }
    `}</style>
  </div>
);

const SeagullSVG = ({ size = 28 }) => (
  <svg width={size} height={size * 0.5} viewBox="0 0 40 20" fill="none">
    <path
      d="M20 10 Q10 0, 0 8 M20 10 Q30 0, 40 8"
      stroke="#475569"
      strokeWidth="2.5"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

const CloudSVG = ({ size = 80 }) => (
  <svg width={size} height={size * 0.6} viewBox="0 0 100 60" fill="white">
    <ellipse cx="30" cy="40" rx="25" ry="18" />
    <ellipse cx="55" cy="35" rx="30" ry="22" />
    <ellipse cx="75" cy="42" rx="20" ry="15" />
  </svg>
);

export default OceanBackground;
